import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  FormControl,
  MenuItem,
  Paper,
  Select,
} from "@mui/material";
import { useState } from "react";
import { useSelector } from "react-redux";

import ConfirmationDialog from "../../../../components/dialog/simple-alert";
import { IMsRole } from "../../../../interfaces/IMsRole";
import { selectUserRole } from "../../../../store/auth/selector";

interface Props {
  openDialog: boolean;
  handleDialogClose(): void;
  handleDialogEdit(): void;
  handleChangeValue(roleName: string): void;
  defaultRoleName: string;
  roleList: IMsRole[];
}

export function EditUserForm({
  openDialog,
  handleDialogClose,
  handleDialogEdit,
  handleChangeValue,
  defaultRoleName,
  roleList,
}: Props): JSX.Element {
  const [dialog, setDialog] = useState(false);
  const getRole = useSelector(selectUserRole);

  return (
    <>
      <Dialog open={openDialog} onClose={handleDialogClose}>
        <Paper
          style={{
            width: "400px",
            padding: "15px",
          }}
        >
          <DialogContent>
            <DialogContentText>
              <div>
                <p className="black">
                  <b>
                    Nama Role / <i>Role Name</i>
                  </b>
                </p>
                <FormControl variant="filled" className="perbesar-width">
                  <Select
                    value={defaultRoleName}
                    onChange={(e) => handleChangeValue(e.target.value)}
                  >
                    {roleList.map((role) => (
                      <MenuItem
                        key={role.roleID}
                        value={role.roleName}
                        disabled={
                          role.roleName === "End User" &&
                          (getRole.roleId === "RL230000003" ||
                            getRole.roleId === "RL230000004")
                        }
                      >
                        {role.roleName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ justifyContent: "space-evenly" }}>
            <Button
              sx={{ background: "#898989", width: "50%" }}
              variant="contained"
              onClick={handleDialogClose}
            >
              Cancel
            </Button>
            <Button
              sx={{ width: "50%" }}
              variant="contained"
              onClick={() => {
                setDialog(true);
              }}
            >
              Save
            </Button>
          </DialogActions>
        </Paper>
      </Dialog>

      <ConfirmationDialog
        open={dialog}
        title="Confirmation Title"
        message="Are you sure you want to proceed?"
        onConfirm={() => {
          handleDialogEdit();
          setDialog(false);
          handleDialogClose();
        }}
        onCancel={() => {
          setDialog(false);
        }}
      />
    </>
  );
}
